import { useParams, Navigate } from "react-router-dom";
import { PppcPolicyWizard } from "@/components/applications/pppc/PppcPolicyWizard";
import { useAllPppcPolicies, usePppcPolicyTags } from "@/hooks/usePppcPolicy";

export default function EditPppcPolicyPage() {
  const { id } = useParams();
  const { data: policies = [], isLoading } = useAllPppcPolicies();
  const { data: tags = [] } = usePppcPolicyTags(id);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  const policy = policies.find((p) => p.policyId === id);
  if (!policy) {
    return <Navigate to="/configurations/pppc" replace />;
  }

  return (
    <PppcPolicyWizard
      initial={{
        existingPolicyId: policy.policyId,
        target: {
          mode: policy.identifierType === "path" ? "external" : "external",
          appName: policy.appName ?? "",
          identifier: policy.identifier,
          identifierType: policy.identifierType,
        },
        permissions: {
          codeRequirement: policy.codeRequirement,
          choices: policy.choices,
        },
        tagIds: tags.map((t) => t.id),
      }}
    />
  );
}
